var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.favorite)?_c('v-icon',{attrs:{"color":"yellow darken-3"},on:{"click":_vm.toggle}},[_vm._v("star")]):_c('v-icon',{on:{"click":_vm.toggle}},[_vm._v("star_border")])
}
var staticRenderFns = []

export { render, staticRenderFns }